// extracted by mini-css-extract-plugin
export default {"changePassword":"styles_changePassword__90UOG","changePassworddark":"styles_changePassworddark__uvx7y","changePasswordTitle":"styles_changePasswordTitle__jhdGs"};